/* RETTERBOX product-quick-view.js
 * NOTE: The modal open/close lifecycle (fetch → #rb-quickview-inner, is-open class,
 * body scroll lock, bottom-sheet animation, backdrop & close-button clicks) is owned
 * ENTIRELY by theme.js. This file only adds the two behaviours theme.js does not have:
 *   1. "Link kopieren" copy-to-clipboard
 *   2. "In den Warenkorb" add-to-cart from inside the modal
 * Do NOT re-add a quickview:open / quickview:close listener here — that caused a
 * double-controller conflict that destroyed #rb-quickview-inner after the first open.
 */
(function () {
  'use strict';

  // ── Copy link button ───────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.rb-modal__copylink');
    if (!btn) return;
    const url = btn.dataset.url || window.location.href;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        window.RB_showToast && window.RB_showToast('Link kopiert!');
      });
    }
  });

  // ── Variant <select> → swap ONLY the info column in place ──────────
  // Fetch the same variant server-side (correct money + Grundpreis formatting) and
  // replace just .rb-modal__info — price, Grundpreis, Vergleichspreis, "Du sparst"
  // tile, details table and add-to-cart all update, without reloading the image,
  // recommendations or accordions and without a full-modal loading flash.
  var qvVariantToken = 0;
  document.addEventListener('change', function (e) {
    const sel = e.target.closest('[data-qv-variant-select]');
    if (!sel) return;
    const modal = sel.closest('.rb-modal');
    if (!modal) return;
    const handle = modal.getAttribute('data-qv-handle');
    const info = modal.querySelector('.rb-modal__info');
    if (!handle || !info) return;

    const token = ++qvVariantToken;
    info.style.opacity = '0.55';
    info.style.pointerEvents = 'none';

    fetch('/products/' + handle + '?view=quick-view&variant=' + encodeURIComponent(sel.value))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (token !== qvVariantToken) return; // a newer switch superseded this one
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('.rb-modal__info');
        if (fresh) info.replaceWith(fresh);
        else { info.style.opacity = ''; info.style.pointerEvents = ''; }
      })
      .catch(function () {
        info.style.opacity = '';
        info.style.pointerEvents = '';
      });
  });

  // ── Add to cart from quick view ────────────────────────────────────
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-quickview-atc]');
    if (!btn) return;
    e.preventDefault();

    const variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;

    btn.disabled = true;
    const original = btn.textContent;
    btn.textContent = '…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify((function () {
          var pr = {};
          if (btn.dataset.pfand) pr._pfand = btn.dataset.pfand;
          if (btn.dataset.ve) pr._ve = btn.dataset.ve;
          if (btn.dataset.maxQty && parseInt(btn.dataset.maxQty, 10) > 0) pr._max_qty = btn.dataset.maxQty;
          if (btn.dataset.cmp && parseInt(btn.dataset.cmp, 10) > 0) pr._cmp = btn.dataset.cmp;
          var o = { id: variantId, quantity: 1 };
          if (Object.keys(pr).length) o.properties = pr;
          return o;
        })())
      });
      if (!res.ok) throw new Error(await res.text());

      // Sync cart UI everywhere
      if (window.RB_syncCart) {
        await window.RB_syncCart();
      } else {
        const cart = await fetch('/cart.js').then(function (r) { return r.json(); });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      }

      // Close the quick-view (theme.js owns the close)
      document.dispatchEvent(new CustomEvent('quickview:close'));

      // Open the cart drawer
      if (window.RB_openCart) window.RB_openCart();
      else document.dispatchEvent(new CustomEvent('cart:open'));

      document.dispatchEvent(new CustomEvent('toast:show', { detail: { message: 'In den Warenkorb gelegt ✓' } }));
    } catch (err) {
      console.error('RETTERBOX: quick-view add to cart failed', err);
      btn.textContent = 'Fehler';
      setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2000);
    }
  });

})();
